import { createSlice } from '@reduxjs/toolkit';
import { normalizeFile } from 'ducks/file/utils';
import { Slices } from 'ducks/slices';
import { FileType } from 'ducks/types/store-types';

const initialState: FileType = {
  file_id: null,
  size_bytes: 0,
  file_bytes: 0,
  starting_byte: 0,
  ending_byte: 0,
};

const fileSlice = createSlice({
  name: Slices.FILE,
  initialState,
  reducers: {
    setFile: (_, action) => {
      return action.payload;
    },
    updateFile: (state, action) => {
      const file = normalizeFile(action.payload);
      return { ...state, ...file };
    },
    clearFile: () => {
      return initialState;
    },
  },
});

export const { setFile, updateFile, clearFile } = fileSlice.actions;

export default fileSlice.reducer;
